<app-dialog [header]="'QUESTIONS.ASK.HEADER' | translate" [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [style]="{ width: '560px' }">
    <!-- Rebuilt on each open so no draft or validation state survives a close. -->
    @if (visible) {
        <app-ask-question-form (submitted)="onSubmitted()" (cancelled)="close()" />
    }
</app-dialog>
